import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Film, Tv, Briefcase, Scissors, Camera, Video, Layers, Megaphone, Clapperboard, Sparkles, Users, HardHat, ArrowUpRight } from "lucide-react";
import { SERVICES_OVERVIEW } from "@/lib/siteData";

const ICONS = { Film, Tv, Briefcase, Scissors, Camera, Video, Layers, Megaphone, Clapperboard, Sparkles, Users, HardHat };

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="section-pad relative bg-background">
      <div className="container-site">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12 sm:mb-16">
          <div>
            <p className="kicker mb-3">What we do</p>
            <h2 className="font-display uppercase text-foreground text-[clamp(2rem,5vw,4rem)] leading-[0.95] text-balance">
              Full-service video production.<br />
              <span className="text-muted-foreground">From brief to broadcast.</span>
            </h2>
          </div>
          <div className="max-w-md text-sm sm:text-base text-muted-foreground">
            <p>We’re a senior video production company in Cape Town - covering the entire filmmaking process with a dedicated in-house team and trusted partners across South Africa.</p>
            <Link to="/services" data-testid="services-view-all" className="inline-block mt-4 text-xs uppercase tracking-[0.22em] text-foreground hover:text-[hsl(var(--primary))] transition-colors border-b border-border pb-1">All services →</Link>
          </div>
        </div>

        <div data-testid="services-grid" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border rounded-2xl overflow-hidden border border-border">
          {SERVICES_OVERVIEW.map((service, i) => {
            const Icon = ICONS[service.icon] || Film;
            return (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: i * 0.04, ease: [0.16, 1, 0.3, 1] }}
              >
                <Link
                  to={service.slug}
                  data-testid={`service-card-${service.id}`}
                  className="group relative block h-full bg-card p-8 sm:p-10 hover:bg-[hsl(225,18%,9%)] transition-colors"
                >
                  <div className="flex items-start justify-between">
                    <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[hsl(225,16%,14%)] border border-border text-[hsl(var(--primary))] group-hover:border-[hsl(var(--primary))]/60 transition-colors">
                      <Icon className="h-5 w-5" />
                    </div>
                    <ArrowUpRight className="h-5 w-5 text-muted-foreground opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                  </div>
                  <h3 className="mt-8 font-display text-2xl uppercase tracking-[0.02em] text-foreground">{service.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{service.desc}</p>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
